export class MT940Parser {
  static parse(fileContent) {
    const lines = fileContent.split('\n').map(line => line.trim());
    const statements = [];
    let consolidatedStatement = null;
    let currentTransaction = null;
    let firstOpeningBalance = '';
    let lastClosingBalance = '';
    let accountNumber = '';
    let sequenceInfo = '';

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];

      if (line.startsWith(':20:')) {
        // Pierwszy wyciąg - utwórz konsolidowany wyciąg
        if (!consolidatedStatement) {
          consolidatedStatement = {
            reference: 'CONSOLIDATED_' + line.substring(4),
            account: '',
            sequence: '',
            openingBalance: '',
            transactions: [],
            closingBalance: ''
          };
        }
      } else if (line.startsWith(':25:')) {
        if (!accountNumber) {
          accountNumber = line.substring(4);
          consolidatedStatement.account = accountNumber;
        }
      } else if (line.startsWith(':28C:')) {
        if (!sequenceInfo) {
          sequenceInfo = line.substring(5);
          consolidatedStatement.sequence = sequenceInfo;
        }
      } else if (line.startsWith(':60F:')) {
        // Użyj pierwszego salda otwarcia
        if (!firstOpeningBalance) {
          firstOpeningBalance = line.substring(5);
          consolidatedStatement.openingBalance = firstOpeningBalance;
        }
      } else if (line.startsWith(':61:') && consolidatedStatement) {
        // Dodaj transakcję do skonsolidowanego wyciągu
        currentTransaction = this.parseTransaction(line);
        consolidatedStatement.transactions.push(currentTransaction);
      } else if (line.startsWith(':86:') && currentTransaction) {
        // Dodatkowe informacje o transakcji
        currentTransaction.additionalInfo = this.parseAdditionalInfo(line, lines, i);
      } else if (line.startsWith(':62F:')) {
        // Zapisz każde saldo końcowe jako potencjalnie ostatnie
        lastClosingBalance = line.substring(5);
      }
    }

    if (consolidatedStatement) {
      consolidatedStatement.closingBalance = lastClosingBalance;
      statements.push(consolidatedStatement);
    }

    return statements;
  }

  static parseTransaction(line) {
    // Format :61:6!n4!n2a1!a15dN3!a16x//16x
    // YYMMDD MMDD C/D N AMOUNT NTRF REFKLI1234567890 //BR05012139000001
    const data = line.substring(4);

    // Data waluty (6 cyfr: YYMMDD)
    const valueDate = data.substring(0, 6);

    // Data księgowania (4 cyfry: MMDD)
    const entryDate = data.substring(6, 10);

    // Debet/Kredyt (C lub D)
    const debitCredit = data.substring(10, 11);

    // 3-cia litera kodu waluty (N dla PLN)
    const currencyLetter = data.substring(11, 12);

    // Wyodrębnienie kwoty (do pierwszej litery)
    let index = 12;
    let amountStr = '';
    while (index < data.length && (data[index].match(/[\d,.]/) || data[index] === ',')) {
      amountStr += data[index];
      index++;
    }

    // Kod transakcji (4 znaki, np. NLDP, NTRF)
    const transactionCode = data.substring(index, index + 4);
    index += 4;

    // Znajdź referencje klienta (do // lub końca)
    const remaining = data.substring(index);
    const refSplit = remaining.split('//');
    const clientRef = refSplit[0].trim();

    // Referencje banku (po //)
    const bankRef = refSplit.length > 1 ? refSplit[1].trim() : '';

    return {
      valueDate,
      entryDate,
      debitCredit,
      currencyLetter,
      amount: amountStr,
      transactionCode,
      clientRef: clientRef === 'NONREF' ? '' : clientRef,
      bankRef,
      type: transactionCode || '',
      reference: bankRef || clientRef,
      additionalInfo: {}
    };
  }

  static parseAdditionalInfo(line, lines, startIndex) {
    const info = {
      description: '',
      transactionCode: '',
      remittanceInfo: '',
      accountNumber: '',
      bankCode: '',
      counterpartyName: '',
      counterpartyAddress: ''
    };

    // Pierwsze linie po :86: zawierają opis
    let currentLine = line.substring(4);
    let index = startIndex + 1;

    // Zbieranie wieloliniowego opisu
    while (index < lines.length && !lines[index].startsWith(':') && lines[index].trim()) {
      currentLine += ' ' + lines[index].trim();
      index++;
    }

    // Zapisz pełny opis
    info.description = currentLine;
    info.fullText = currentLine;

    // Analiza szczegółów w opisie
    const fullText = currentLine;

    // Wyodrębnienie numeru rachunku z wzorca "Z RACH.:" lub "NA RACH.:"
    const accountMatch = fullText.match(/(?:Z RACH\.|NA RACH\.): ([0-9]{26})/);
    if (accountMatch) {
      info.accountNumber = accountMatch[1];
      info.bankCode = accountMatch[1].substring(2, 10);
    }

    // Wyodrębnienie nazwy kontrahenta z wzorca "OD:" lub "DLA:"
    const nameMatch = fullText.match(/(?:OD|DLA): ([^;]+?)(?:;|UL\.|AL\.|$)/);
    if (nameMatch) {
      info.counterpartyName = nameMatch[1].trim();
    }

    // Wyodrębnienie adresu
    const addressMatch = fullText.match(/UL\.([^;]+?)(?:;|TYT\.|$)/);
    if (addressMatch) {
      info.counterpartyAddress = 'UL.' + addressMatch[1].trim();
    }

    // Wyodrębnienie tytułu płatności
    const titleMatch = fullText.match(/TYT\.:\s*([^;]+)/);
    if (titleMatch) {
      info.remittanceInfo = titleMatch[1].trim();
    }

    return info;
  }

  static generateTimestamp() {
    const now = new Date();
    const year = now.getFullYear().toString();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');

    return year + month + day + hours + minutes + '0000';
  }
}